import { render, staticRenderFns } from "./relatorio.vue?vue&type=template&id=5b0e134d&"
import script from "./relatorio.vue?vue&type=script&lang=js&"
export * from "./relatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard,QCardSection,QBtn} from 'quasar'
component.options.components = Object.assign({QPage,QCard,QCardSection,QBtn}, component.options.components || {})
